import { StyleSheet, View } from "@react-pdf/renderer";
import { GoodLuckSettings } from "p6m-p6u";
import { ReactNode } from "react";
import DesignConstants from "../../../constants/DesignConstants";
import PDFGoodLuckImage from "./PDFGoodLuckImage";
import { SettingPosition } from "../../../enums/settings";
import { useT } from "@transifex/react";

interface PDFGoodLuckImageWrapperProps {
    children: ReactNode;
    isLastElement: boolean;
    goodLuckSettings: GoodLuckSettings;
    showImageBelowExercise?: boolean;
    isSolution?: boolean;
}

export const PDFGoodLuckImageWrapper = (props: PDFGoodLuckImageWrapperProps) => {
    const t = useT();
    const t_goodLuck = t("Good Luck!", { _tags: "PDFConfiguration" });

    const showGoodLuckImage = props.goodLuckSettings.show;
    const customGoodLuckText = props.goodLuckSettings.text;

    const position = props.goodLuckSettings.position;
    const settingImageBottomIsActive = showGoodLuckImage && position === SettingPosition.BOTTOM;
    const showImage = props.isLastElement && settingImageBottomIsActive && !props.isSolution;

    return (
        <View
            style={{
                ...styles.goodLuckContainer,
                flexDirection: props.showImageBelowExercise ? "column" : "row",
            }}
        >
            {showImage && !props.showImageBelowExercise ? (
                <View style={{ flex: 1 }}>{props.children}</View>
            ) : (
                props.children
            )}
            {showImage && (
                <View
                    style={{
                        ...styles.goodLuckImageWrapper,
                        justifyContent: props.showImageBelowExercise ? "flex-end" : "flex-start",
                    }}
                >
                    <PDFGoodLuckImage
                        goodLuckText={customGoodLuckText === "default_good_luck_text" ? t_goodLuck : customGoodLuckText}
                        goodLuckImageName={props.goodLuckSettings.value}
                    />
                </View>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    goodLuckContainer: {
        display: "flex",
        gap: DesignConstants.PDF.GAP_S,
    },
    goodLuckImageWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        border: `${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.WHITE}`,
    },
});
